import React from "react";
import { compose } from "redux";
import { Redirect } from "react-router";
import { useLocation } from "react-router-dom";

import { UrlProvider } from "../../../../../api/UrlProvider";
import withLoginForm from "../../../../../hocs/withLoginForm";
import withTranslations from "../../../../../hocs/withTranslations";
import withUserData from "../../../../../hocs/withUserData";
import { resolvePostAuthRedirectPath } from "../../../../../lib/auth/authRedirectUrl";
import { appendSearchToUrl } from "../../../../../lib/url/appendQueryStringToUrl";
import "../../../auth/authForm.scss";
import OtpLoginForm from "../components/OtpLoginForm";
import PasswordLoginForm from "../components/PasswordLoginForm";

function NewLoginPage({
  formBuilder,
  login,
  loginLoading,
  otpRequest,
  otpRequestLoading,
  isPasswordLogin,
  userData,
  locale,
  translate
}) {
  const { search } = useLocation();

  if (userData) {
    return <Redirect to={resolvePostAuthRedirectPath(search)} />;
  }

  const registerTo = appendSearchToUrl(
    UrlProvider.getUrl("fe.register", { locale }),
    search
  );

  if (isPasswordLogin) {
    return (
      <PasswordLoginForm
        formBuilder={formBuilder}
        login={login}
        loginLoading={loginLoading}
        locale={locale}
        translate={translate}
        registerTo={registerTo}
      />
    );
  }

  return (
    <OtpLoginForm
      formBuilder={formBuilder}
      otpRequest={otpRequest}
      otpRequestLoading={otpRequestLoading}
      locale={locale}
      translate={translate}
      search={search}
      registerTo={registerTo}
    />
  );
}

export default compose(
  withTranslations,
  withLoginForm,
  withUserData
)(NewLoginPage);
